import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSelect = (url: string, key: string) => {
    setSelected(key);
    setOpen(false);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="relative w-full max-w-xl" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between rounded-lg border border-background-300 bg-white px-4 py-3 text-left text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400"
        aria-label={t('category.dropdownLabel')}
      >
        <span className="flex items-center gap-2">
          <i className="ri-apps-2-line text-primary-600"></i>
          {selected ? t(`category.${selected}`) : t('category.dropdownPlaceholder')}
        </span>
        <i className={`ri-arrow-down-s-line transition-transform ${open ? 'rotate-180' : ''}`}></i>
      </button>

      {open && (
        <div className="absolute z-50 mt-2 max-h-80 w-full overflow-y-auto rounded-lg border border-background-200 bg-white py-1 shadow-sm">
          {categories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              onClick={() => handleSelect(cat.url, cat.key)}
              className="flex w-full items-center justify-between px-4 py-2.5 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100"
            >
              <span className="whitespace-nowrap">{t(`category.${cat.key}`)}</span>
              <i className="ri-external-link-line text-foreground-400"></i>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}